/**
 * `filter_by` for GET /ats_jobs/list_templates, shared by the scorecard
 * (`ats_scorecard`) and interview-plan (`ats_job_stage`) lists — one backend
 * endpoint serves both, so one builder serves both callers.
 *
 * Keeping this in one place is deliberate: CORE-5222 shipped because the two
 * copies of this mapping drifted from the filter config that feeds them.
 */

type FilterOption = {
  id?: number | string;
  value?: number | string;
};

export type ListTemplatesFilters = {
  department_ids?: FilterOption[];
  office_ids?: FilterOption[];
  employment_type?: FilterOption[];
  ats_work_type_ids?: FilterOption[];
};

export const buildListTemplatesFilterBy = (
  filters: ListTemplatesFilters = {}
): Record<string, (number | string | undefined)[]> => {
  const filterBy: Record<string, (number | string | undefined)[]> = {};

  if (filters?.department_ids?.length) {
    filterBy.department_ids = filters.department_ids.map(({ id }) => id);
  }

  if (filters?.office_ids?.length) {
    filterBy.office_ids = filters.office_ids.map(({ id }) => id);
  }

  if (filters?.employment_type?.length) {
    filterBy.employment_type = filters.employment_type.map(
      ({ value }) => value
    );
  }

  // Flag on, the filter config swaps the key to `ats_work_type_ids` and the
  // option `value` carries a work-type id instead of an enum string. The two
  // keys are mutually exclusive in practice — the config only ever emits one —
  // but both are read so neither flag state depends on the other's absence.
  if (filters?.ats_work_type_ids?.length) {
    filterBy.ats_work_type_ids = filters.ats_work_type_ids.map(
      ({ value }) => value
    );
  }

  return filterBy;
};
